import React, { useEffect, useState } from "react";
import { useI18n } from "../../i18n/I18nContext";
import { api, apiError } from "../../lib/api";
import { toast } from "sonner";
import { Plug, CheckCircle2, XCircle } from "lucide-react";

const STATUS_OPTS = ["demo", "not_connected", "test", "production"];

export default function Integrations() {
  const { t, localize, isAr } = useI18n();
  const [rows, setRows] = useState([]);
  const load = () => api.get("/admin/integrations").then((r) => setRows(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const update = async (key, status) => {
    try { await api.put(`/admin/integrations/${key}`, { status }); toast.success(t("common.save")); load(); }
    catch (e) { toast.error(apiError(e)); }
  };
  const test = async (key) => {
    try { const { data } = await api.post(`/admin/integrations/${key}/test`); data.ok ? toast.success(isAr ? data.reason_ar || "نجح" : data.reason_en) : toast.error(isAr ? data.reason_ar : data.reason_en); }
    catch (e) { toast.error(apiError(e)); }
  };
  const badge = (s) => ({ demo: "bg-amber-100 text-amber-700", not_connected: "bg-slate-100 text-slate-500", test: "bg-blue-100 text-blue-700", production: "bg-green-100 text-green-700" }[s]);

  return (
    <div>
      <h1 className="text-xl font-bold text-slate-900">{t("admin.integrations")}</h1>
      <p className="mt-1 text-sm text-slate-500">{isAr ? "أدر حالة كل موصل. الوظائف تعمل بوضع تجريبي حتى تُضاف مفاتيح الإنتاج." : "Manage each connector. Functions run in demo mode until production keys are added."}</p>
      <div className="mt-5 grid grid-cols-1 gap-4 md:grid-cols-2">
        {rows.map((r) => (
          <div key={r.key} data-testid={`integration-${r.key}`} className="rounded-xl border border-border bg-white p-5">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-3">
                <div className="inline-flex h-10 w-10 items-center justify-center rounded-lg bg-primary/10 text-primary"><Plug className="h-5 w-5" /></div>
                <div><div className="font-semibold text-slate-900">{localize(r, "name")}</div><span className={`mt-1 inline-block rounded-full px-2 py-0.5 text-xs font-medium ${badge(r.status)}`}>{t(`integ.${r.status}`)}</span></div>
              </div>
            </div>
            <div className="mt-4 flex flex-wrap items-center gap-2">
              <select value={r.status} onChange={(e) => update(r.key, e.target.value)} data-testid={`integration-status-${r.key}`} className="rounded-lg border border-border px-3 py-1.5 text-sm">
                {STATUS_OPTS.map((s) => <option key={s} value={s}>{t(`integ.${s}`)}</option>)}
              </select>
              <button onClick={() => test(r.key)} data-testid={`integration-test-${r.key}`} className="inline-flex items-center gap-1.5 rounded-lg border border-border px-3 py-1.5 text-sm hover:border-primary">
                {["test", "production"].includes(r.status) ? <CheckCircle2 className="h-4 w-4 text-green-500" /> : <XCircle className="h-4 w-4 text-slate-400" />}
                {t("integ.test_btn")}
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
